import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26b31c9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w100 modal-import-detail" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "导入选择文件后,会出现对应关系的表格，表格说明如下："),
      /*#__PURE__*/_createElementVNode("table", { border: "1" }, [
        /*#__PURE__*/_createElementVNode("tbody", null, [
          /*#__PURE__*/_createElementVNode("tr", null, [
            /*#__PURE__*/_createElementVNode("td", { width: "60" }, "第一列:"),
            /*#__PURE__*/_createElementVNode("td", null, "  Excel文件标题: 这一列是文件中sheet的第二行的提示数据，标题列至少3列，最多6列，如无相关信息可以不填写。")
          ]),
          /*#__PURE__*/_createElementVNode("tr", null, [
            /*#__PURE__*/_createElementVNode("td", null, "第二列:"),
            /*#__PURE__*/_createElementVNode("td", null, "  对应系统中的字段: 这一列与文件无关，是属于内部存储数据的字段，选择了对应字段后，则会将Excel文件中与标题列对应的数据导入对应字段(如: Excel中标题列的字段是:a，对应字段是:姓名，则文件中的a这一列识别为客户的姓名)，对应字段中必须包含姓名、电子邮件和社区角色字段且必须填写。")
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "注意事项："),
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, "对应字段中必须包含姓名、电子邮件和社区角色列且必须填写，其他列可以不填，但标题列不能少于3列，不能超过6列。"),
        /*#__PURE__*/_createElementVNode("li", null, "如果导入时没有选择昵称或者昵称没有填写，则昵称默认为姓名。"),
        /*#__PURE__*/_createElementVNode("li", null, "社区角色的值只能是：‘访客’、‘作者’、‘编辑’，如果填写其他系统将无法识别。"),
        /*#__PURE__*/_createElementVNode("li", null, "导入客服组和角色时，如果填写已存在的，则分配对应的客服组和角色，否则客服组为自动添加到默认服务台，角色自动设置为客服。"),
        /*#__PURE__*/_createElementVNode("li", null, "如果角色为管理员，那么社区角色自动转换为编辑，与后面选择的无关。"),
        /*#__PURE__*/_createElementVNode("li", null, "需要导入的文件中，不能出现重复的电子邮箱、手机号码。"),
        /*#__PURE__*/_createElementVNode("li", null, "电子邮箱的格式必须按照aa@bb.cc(.dd)的格式填写，如(ewei@qq.com、ewei@163.com.cn,ewei@vip.qq.com等)。"),
        /*#__PURE__*/_createElementVNode("li", null, "手机号码必须是正常的11位手机号码。")
      ])
    ])
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.showModal,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showModal) = $event)),
    title: "客服导入详细说明",
    style: {"width":"680px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "submit",
        type: "primary",
        onClick: _ctx.handleOk
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["visible"]))
}